import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
} from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { Close } from 'assets/images'
import Button from 'components/Button/Index'
import React from 'react'

interface TimingValidationDialogProps {
  open: boolean
  onClose: () => void
  message: string
}

function TimingValidationDialog(props: TimingValidationDialogProps) {
  const { open, onClose, message } = props

  return (
    <Dialog
      className="primary-dialog alert-dialog timing-validation-dialog"
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <AccessTimeIcon color="info" sx={{ fontSize: 28 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Please Wait a Moment
          </Typography>
          <Button
            variant="text"
            title="Close"
            onClick={onClose}
            className="icon-btn rounded ml-auto"
            color="inherit"
          >
            <img src={Close} alt="Close" />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent className="pb-0">
        <Typography variant="body1" paragraph sx={{ mb: 2 }}>
          {message}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This waiting period helps ensure your order is properly prepared and
          processed. You&apos;ll be able to close your tab and complete payment
          once this time has passed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <div className="btn-list">
          <Button
            variant="contained"
            onClick={onClose}
            fullWidth
            size="large"
            color="inherit"
          >
            I Understand
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default TimingValidationDialog
